module.exports = __webpack_public_path__ + "img/personal-counter-dropdown-video-firsttreeplanted.2f2d247.png";